module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications"
    }
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('div', {
      class: _vm.getNotificationClass(notification)
    }, [_vm._v("\n        " + _vm._s(notification.message) + "\n    ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ea1cf8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/notifications.vue
// module id = 369
// module chunks = 1